import React from 'react';

import iPlaceholder from 'assets/icon/token/default.svg';
import { wrapUrlInImg } from 'consts/tokenInfos';

export function getTokenSymbol(token?: {
  optimized_symbol?: string;
  display_symbol?: string;
  symbol?: string;
}) {
  return token?.optimized_symbol || token?.display_symbol || token?.symbol || '';
}

export function wrapUrlInImgOrDefault(
  url?: string,
  size?: number,
  style?: React.CSSProperties,
  placeHolder: string = iPlaceholder,
) {
  return url ? (
    wrapUrlInImg(url, undefined, size, style)
  ) : (
    <img src={placeHolder} style={{ ...style, width: size || 20, height: size || 20 }} alt={''} />
  );
}

export const getNftTokenSymbol = (token: Tokens) => {
  let _symbol = token ? getTokenSymbol(token) : '';
  const _isNft = token.id.length === 32;

  return _isNft
    ? token?.name || (_symbol ? `${_symbol} ${token?.inner_id}` : 'Unknown NFT')
    : _symbol;
};
